
const SplashScreen = ({ visible, closeDisplay }:{ visible?:boolean, closeDisplay?:boolean }) => (
    <div className={`modalParentContainer${visible ? "" : " animate__animated animate__fadeOut animate__delay-1s" }${closeDisplay ? " d-none":""}`} style={{backgroundColor:"#0D0404", zIndex:"999999"}}>
        <div className="modalContainer" style={{overflow:'hidden'}}>
                <img src={require('../assets/splash.png')} alt='splash' style={{width:'100%'}} />
        </div>
    </div>
)

export default SplashScreen;